import { render } from "./UserFilterMenu.vue?vue&type=template&id=5be9f7d0"
import script from "./UserFilterMenu.vue?vue&type=script&lang=js"
export * from "./UserFilterMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__